import { StringMap } from '../utils/TypeDefinitions';
import { sentryConfig } from './SentryConfig';

declare global {
	interface Window {
		setupSentry: Function;
	}
}

window.setupSentry = function (initData: StringMap): void {
	if (initData.sentrySupport) {
		sentryConfig.sentrySupport = JSON.parse(initData.sentrySupport.toLowerCase());
	}
	if (initData.environment) {
		sentryConfig.environment = initData.environment;
	}
	if (initData.branch) {
		sentryConfig.branch = initData.branch;
	}
	if (initData.version) {
		sentryConfig.version = initData.version;
	}
	if (initData.processName) {
		sentryConfig.processName = initData.processName;
	}
	if (initData.clientId) {
		sentryConfig.clientId = initData.clientId;
	}
};
